import type { TypedUseSelectorHook } from 'react-redux';
import { useDispatch, useSelector } from 'react-redux';
import { store } from './store';

export type RootStateType = ReturnType<typeof store.getState>;
export type AppStore = typeof store;
export type AppDispatchType = typeof store.dispatch;
export const useAppSelector: TypedUseSelectorHook<RootStateType> = useSelector;
export const useAppDispatch: () => AppDispatchType = useDispatch;
